import React from 'react';
import { LoaderIcon, SaveIcon } from 'lucide-react';
import type { TotadminPermission } from 'data/__generated__';
import { TotemPrimaryButton } from './TotemPrimaryButton';

interface TotemPrimaryLoadingButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    loading?: boolean;
    $minWidth?: string;
    $isSecondaryStyle?: boolean;
    $isDangerStyle?: boolean;
    icon?: React.ReactNode;
    label?: string;
    useIcon?: boolean;
    /** Transmis à `TotemPrimaryButton` : grisé + cadenas si un de ces droits manque. */
    requiredPermissions?: readonly TotadminPermission[];
}

export const TotemPrimaryLoadingButton: React.FC<TotemPrimaryLoadingButtonProps> = ({
    loading = false,
    disabled,
    icon,
    label,
    useIcon = true,
    $minWidth,
    ...props
}) => {
    return (
        <TotemPrimaryButton disabled={disabled || loading} $minWidth={$minWidth} {...props}>
            {loading ? (
                <LoaderIcon className="size-4 animate-spin" />
            ) : (
                <>
                    {useIcon ? (icon ?? <SaveIcon className="size-3.5" />) : null}
                    {label ? <span>{label}</span> : null}
                </>
            )}
        </TotemPrimaryButton>
    );
};
